export const getClaimAggregates = (claimAggregates, claimBlock) =>
  claimAggregates?.filter((aggregate) => aggregate.ucr === claimBlock) || null;
